import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import SessionCalendarNewView from "./sessionCalendarNew.view";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";

const SessionCalendarNewContainer = ({ sessions }) => {
  const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(moment());
  const [calendarData, setCalendarData] = useState({});

  useEffect(() => {
    if (sessions && sessions.length > 0) {

      // Organizar las sesiones por fecha
      const sessionsByDate = sessions.reduce((acc, session) => {
        // Usamos la fecha de la sesión
        const date = moment(session.date).format("YYYY-MM-DD");

        if (!acc[date]) {
          acc[date] = [];
        }

        // Agregamos la sesión completa con toda la información relevante
        acc[date].push({
          ...session, // Incluimos toda la sesión original
          uuid: session.uuid,
          farm: session.meeting?.farm || "",
          course: session.meeting?.course?.name || "",
          speaker: session.user?.name || "",
          time: moment(session.date).format("HH:mm"),
          employees: session.employees || [],
          completed: session.completed,
          meeting: session.meeting, // Aseguramos que meeting esté disponible
          user: session.user, // Aseguramos que user esté disponible
        });

        return acc;
      }, {});

      setCalendarData(sessionsByDate);
    }
  }, [sessions]);

  const handlePreviousMonth = () => {
    setCurrentDate(moment(currentDate).subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setCurrentDate(moment(currentDate).add(1, "month"));
  };

  const handleViewSession = (session) => {
    navigate(`/adm/session/attendance/${session.uuid}`, {
      state: session,
    });
  };

  return (
    <SessionCalendarNewView
      currentDate={currentDate}
      calendarData={calendarData}
      onPreviousMonth={handlePreviousMonth}
      onNextMonth={handleNextMonth}
      onSessionClick={handleViewSession}
    />
  );
};

SessionCalendarNewContainer.propTypes = {
  sessions: PropTypes.array.isRequired,
};

export default SessionCalendarNewContainer;
